module.exports = "/static/assets/4984a14327d6912c79d89b58bfdd061b.png";